import { z } from 'zod';
import { characterTraitSchema } from './profile.js';
/**
 * "Crie o seu": o avatar do Secretário feito a partir de uma selfie da própria
 * pessoa. A foto vai ao Google (Gemini) só para desenhar e não fica guardada;
 * fica o desenho, em 6 expressões.
 */
export const OWN_AVATAR_STYLES = ['toy', 'massinha', 'ilustracao'];
/**
 * Estilos que a tela oferece hoje. O 3D Toy saiu da escolha (o servidor ainda
 * aceita, por causa dos apps antigos e dos avatares já desenhados nele).
 */
export const OWN_AVATAR_STYLES_OFFERED = [
    'massinha',
    'ilustracao',
];
export const OWN_AVATAR_STYLE_LABEL = {
    toy: '3D Toy',
    massinha: 'Massinha',
    ilustracao: 'Ilustração',
};
/** Versão do texto de consentimento da foto (fica registrada em consent_events). */
export const AVATAR_PHOTO_CONSENT_VERSION = 1;
export const avatarPreviewRequestSchema = z.object({
    style: z.enum(OWN_AVATAR_STYLES),
    /** Selfie em base64 (sem o prefixo data:), já reduzida no aparelho. */
    photo: z
        .string()
        .min(1000)
        .max(4_000_000)
        .regex(/^[A-Za-z0-9+/=]+$/),
    mime: z.enum(['image/jpeg', 'image/png', 'image/webp']),
    /** Caixa "Concordo com o envio da minha foto ao Google", marcada pela pessoa. */
    consent: z.literal(true),
});
export const avatarQuotaSchema = z.object({
    /** Pode pedir mais uma versão agora. */
    canPreview: z.boolean(),
    /** Pode guardar mais um avatar agora. */
    canCreate: z.boolean(),
    /** O primeiro é grátis; depois, Basic e PRO. */
    needsPlan: z.boolean(),
    previewsLeft: z.number().int().min(0),
});
export const avatarPreviewSchema = z.object({
    previewId: z.uuid(),
    /** WebP com fundo transparente, em data URL. */
    image: z.string().startsWith('data:image/'),
    quota: avatarQuotaSchema,
});
export const avatarConfirmRequestSchema = z.object({ previewId: z.uuid() });
export const ownAvatarSchema = z.object({
    id: z.string().regex(/^[0-9a-f]{32}$/),
    characterKey: z.custom((value) => typeof value === 'string' && /^own-[0-9a-f]{32}$/.test(value)),
    style: z.enum(OWN_AVATAR_STYLES),
    /** Expressões já desenhadas; as que faltam usam a principal até ficarem prontas. */
    expressions: z.array(characterTraitSchema),
    createdAt: z.string(),
});
export const avatarStatusSchema = z.object({
    avatar: ownAvatarSchema.nullable(),
    quota: avatarQuotaSchema,
});
export function isOwnAvatarKey(key) {
    return /^own-[0-9a-f]{32}$/.test(key);
}
